import { forwardRef, Ref, SVGProps } from 'react';

interface Props extends SVGProps<SVGSVGElement> {
  size?: string | number;
}

export const DiamondIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => {
  const { size = 32, ...others } = props;

  return (
    <svg
      fill="none"
      height={size}
      ref={ref}
      viewBox="0 0 32 32"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <path
        d="M14.5858 1.41421C15.3668 0.633164 16.6332 0.633165 17.4142 1.41421L30.5858 14.5858C31.3668 15.3668 31.3668 16.6332 30.5858 17.4142L17.4142 30.5858C16.6332 31.3668 15.3668 31.3668 14.5858 30.5858L1.41421 17.4142C0.633164 16.6332 0.633165 15.3668 1.41421 14.5858L14.5858 1.41421Z"
        fill="#F04E4A"
      />
      <path
        clipRule="evenodd"
        d="M14.9825 8L14.9825 18.9614H16.7279L16.7279 8H14.9825ZM14.9824 21.1539L14.9824 23.3462H16.7279L16.7279 21.1539H14.9824Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
});

export const InfoIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => {
  const { size = 32, ...others } = props;
  return (
    <svg
      fill="none"
      height={size}
      ref={ref}
      viewBox="0 0 24 25"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <circle cx="12" cy="12.1587" fill="#44AEC9" r="11" />
      <path
        clipRule="evenodd"
        d="M12.5 17.6587L12.5 10.1227L11.3 10.1227L11.3 17.6587L12.5 17.6587ZM12.5 8.61553L12.5 7.10834L11.3 7.10834L11.3 8.61553L12.5 8.61553Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
});

export const WarningIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => {
  const { size = 32, ...others } = props;
  return (
    <svg
      fill="none"
      height={size}
      ref={ref}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <path
        d="M10.7043 3.23077C11.2802 2.25641 12.7198 2.25641 13.2957 3.23077L22.7973 19.3077C23.3732 20.2821 22.6534 21.5 21.5016 21.5H2.49835C1.34664 21.5 0.626817 20.2821 1.20267 19.3077L10.7043 3.23077Z"
        fill="#F7BE2C"
      />
      <path
        clipRule="evenodd"
        d="M11.3 7.5L11.3 15.036H12.5L12.5 7.5H11.3ZM11.3 16.5432V18.0504H12.5L12.5 16.5432H11.3Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
});
